











import { Component, Prop, Vue } from 'vue-property-decorator';
import { PermissionType } from '@shared/common/types';
import ConfirmModal from '../../core/components/ConfirmModal.vue';
import { Device } from '../device';
import { deviceApi } from '../device.api';

@Component
export default class DevicePinCodeUpdateBtn extends Vue {
  @Prop()
  public device!: Device;

  public updating = false;
  public PermissionType = PermissionType;

  public get isBtnVisible(): boolean {
    return this.$can(PermissionType.updateDevice) && !this.device.deletedAt;
  }

  public async updatePinCode(): Promise<void> {
    this.updating = true;
    const pinCode = Device.generatePinCode();

    try {
      await deviceApi.updatePinCode(this.device.id, pinCode);
      this.$buefy.snackbar.open({
        message: 'Code pin mis à jour',
        type: 'is-success',
      });
      this.$emit('updated');
      this.updating = false;
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Erreur lors de la mise à jour du code pin',
        type: 'is-danger',
      });
      this.updating = false;
      throw _;
    }
  }

  public openConfirmModal(): void {
    this.$buefy.modal.open({
      hasModalCard: true,
      component: ConfirmModal,
      props: {
        title: `Mise à jour du code PIN #${this.device.incrementalId}`,
        bodyHtml: `Vous allez mettre à jour le code PIN du terminal <b>${this.device.incrementalId}</b>.`,
        uncancellableActionWarning: true,
        confirmAction: this.updatePinCode.bind(this),
      },
    });
  }
}
